
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { viagemStore } from '@/store';

@Component
export default class ShowViagens extends Vue {
  @Prop(String) readonly aabb;

  @Watch('aabb')
  onChangeSearchUf(val) {
    this.data = val;
    this.show(this.data);
  }

  public headers = [
    {
      text: 'Descrição',
      value: 'descricao',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'left',
    },
  ];
  public items = [];

  public itemsOngoing = [];

  public itemsEnd = [];

  public viagens = [];

  public viagensOngoing = [];

  public viagensEnd = [];

  public loadingContent = false;

  public dialog = false;

  public data: string = '';

  public getItens() {
    let arr: any = [];
    for (let i = 0; i < this.viagens.length; i++) {
      const obj = {
        //@ts-ignore
        descricao: `${this.viagens[i].user} - ${this.viagens[i].destino} ${this.viagens[i].destino_uf}`,
        //@ts-ignore
        link: this.viagens[i].link_drive,
        //@ts-ignore
        id: this.viagens[i].id,
      };
      arr.push(obj);
    }
    this.items = arr;
    arr = [];
    for (let i = 0; i < this.viagensOngoing.length; i++) {
      const obj = {
        //@ts-ignore
        descricao: `${this.viagensOngoing[i].user} - ${this.viagensOngoing[i].destino} ${this.viagensOngoing[i].destino_uf}`,
        //@ts-ignore
        link: this.viagensOngoing[i].link_drive,
        //@ts-ignore
        id: this.viagensOngoing[i].id,
      };
      arr.push(obj);
    }
    this.itemsOngoing = arr;
    arr = [];
    for (let i = 0; i < this.viagensEnd.length; i++) {
      const obj = {
        //@ts-ignore
        descricao: `${this.viagensEnd[i].user} - ${this.viagensEnd[i].destino} ${this.viagensEnd[i].destino_uf}`,
        //@ts-ignore
        link: this.viagensEnd[i].link_drive,
        //@ts-ignore
        id: this.viagensEnd[i].id,
      };
      arr.push(obj);
    }
    this.itemsEnd = arr;
  }

  public openLink(item) {
    window.open('//' + item['link']);
  }

  public async editRoute(item) {
    //@ts-ignore
    const viagem = await viagemStore.getViagem(item.id);
    const id: string = viagem.id;

    this.$router.push({
      name: 'main-gestao-viagem-edit',
      params: { id: id, isReadOnly: 'true' },
    });
  }

  public async show(params) {
    this.loadingContent = true;
    this.data = params;
    this.viagens = await viagemStore.getViagensByInitialDate(this.data);
    this.viagensOngoing = await viagemStore.getViagensOngoingAtDate(this.data);
    this.viagensEnd = await viagemStore.getViagensByEndDate(this.data);
    this.getItens();
    this.data = this.data.replace('-', '/').replace('-', '/');
    this.dialog = true;
    this.loadingContent = false;
  }
}
